import { Component, ViewChild, OnInit, AfterContentChecked, AfterViewInit, ElementRef, HostListener, Inject } from "@angular/core";
import { FormGroup, FormControl, FormBuilder, Validators } from '@angular/forms';
import { NgAnimateScrollService } from 'ng-animate-scroll';
import smoothscroll from 'smoothscroll-polyfill';
import { CustomValidators } from 'ngx-custom-validators';
import { DOCUMENT } from '@angular/common';
import { BackendService } from "../services/backend.service";
import * as xml2js from 'xml2js';
import { DeviceDetectorService } from 'ngx-device-detector';
import { Model } from './home.interfaces';
import { ImageLightboxComponent } from "../components/image-lightbox/image-lightbox.component";

@Component({
  selector: "app-home",
  templateUrl: "home.component.html",
  styleUrls: ["home.component.scss"]
})
export class HomeComponent implements OnInit {

  focus;
  valForm: FormGroup;

  logoTunlandG9 = "assets/img/LogoTunlandG9.webp";
  logoTunlandG7 = "assets/img/LogoTunlandG7.webp";
  logoASSA = "assets/img/LogoASSA.png";
  logo = "assets/img/LogoFoton+Tunland.png";

  nubes = "assets/img/background2.jpg";

  background4 = "url('assets/img/GALERIA.jpg')";

  logoTunland = "assets/img/LogoTunland.webp";

  muted = true;

  visible = true;

  autoplay = true;

  send = false;

  controls = false;

  playing = true;

  firstTime = false;

  models: Array<Model> = [
    // Tunland G7
    {
      index: 0,
      title: 'assets/img/Models/G7/g7-title.webp',
      videos: ['assets/video/FOTON TUNLAND.mov'],
      dataSheet: 'assets/pdf/tunlandG7.pdf',
      colors: [
        {
          index: 0,
          color: '#000000',
          image: 'assets/img/Models/G7/Colors/g7-black.webp',
          title: 'assets/img/Models/G7/g7-title-alt.webp',
          thick: 'white',
        },
        {
          index: 1,
          color: '#FFFFFF',
          image: 'assets/img/Models/G7/Colors/g7-white.webp',
          title: 'assets/img/Models/G7/g7-title-alt.webp',
          thick: 'black',
        },
        {
          index: 2,
          color: '#718080',
          image: 'assets/img/Models/G7/Colors/g7-silver.webp',
          title: 'assets/img/Models/G7/g7-title-alt.webp',
          thick: 'white',
        },
        {
          index: 3,
          color: '#38464A',
          image: 'assets/img/Models/G7/Colors/g7-grey.webp',
          title: 'assets/img/Models/G7/g7-title-alt.webp',
          thick: 'white',
        },
        {
          index: 4,
          color: '#001C92',
          image: 'assets/img/Models/G7/Colors/g7-blue.webp',
          title: 'assets/img/Models/G7/g7-title-alt.webp',
          thick: 'white',
        },
        {
          index: 5,
          color: '#D7000A',
          image: 'assets/img/Models/G7/Colors/g7-red.webp',
          title: 'assets/img/Models/G7/g7-title-alt.webp',
          thick: 'white',
        }
      ],
      gallery: [
        {
          index: 0,
          url: "assets/img/Models/G7/Gallery/TUNLAND-G7-2024playa_-V4.jpg",
          alt: "800",
          id: "800",
        },
        {
          index: 1,
          url: "assets/img/Models/G7/Gallery/DSC_8740.jpg",
          alt: "801",
          id: "801",
        },
        {
          index: 2,
          url: "assets/img/Models/G7/Gallery/Foton-Tunland59775-VOLANTE-RETOQUE-BAJA.jpg",
          alt: "803",
          id: "803",
        },
        {
          index: 3,
          url: "assets/img/Models/G7/Gallery/Foton-Tunland59897-RETOQUE-EN-BAJA.jpg",
          alt: "805",
          id: "805",
        },
      ],
      submodels: [
        {
          index: 0,
          model: 'assets/img/Models/G7/Submodels/4x2/g7-4x2-title.webp',
          image: 'assets/img/Models/G7/Submodels/4x2/g7-4x2-model.webp',
          characteristics: [
            {
              index: 0,
              title: 'NUEVA ERA EN POTENCIA',
              subtitle: 'Motor / Transmisión',
              image: 'assets/img/Models/G7/Submodels/4x2/char-1.webp',
              table: []
            },
            {
              index: 1,
              title: 'NUEVA ERA EN SEGURIDAD',
              subtitle: 'Motor / Transmisión',
              image: 'assets/img/Models/G7/Submodels/4x2/char-4.webp',
              table: []
            },
            {
              index: 2,
              title: 'NUEVA ERA EN COMODIDAD',
              subtitle: 'Motor / Transmisión',
              image: 'assets/img/Models/G7/Submodels/4x2/char-2.webp',
              table: []
            },
            {
              index: 3,
              title: 'NUEVA ERA EN EQUIPAMIENTO',
              subtitle: 'Motor / Transmisión',
              image: 'assets/img/Models/G7/Submodels/4x2/char-3.webp',
              table: []
            },
          ]
        },
        {
          index: 1,
          model: 'assets/img/Models/G7/Submodels/4x4 MT/g7-4x4-mt-title.webp',
          image: 'assets/img/Models/G7/Submodels/4x4 MT/g7-4x4-model.webp',
          characteristics: [
            {
              index: 0,
              title: 'NUEVA ERA EN POTENCIA',
              subtitle: 'Motor / Transmisión',
              image: 'assets/img/Models/G7/Submodels/4x4 MT/char-1.webp',
              table: []
            },
            {
              index: 1,
              title: 'NUEVA ERA EN SEGURIDAD',
              subtitle: 'Motor / Transmisión',
              image: 'assets/img/Models/G7/Submodels/4x4 MT/char-4.webp',
              table: []
            },
            {
              index: 2,
              title: 'NUEVA ERA EN COMODIDAD',
              subtitle: 'Motor / Transmisión',
              image: 'assets/img/Models/G7/Submodels/4x4 MT/char-2.webp',
              table: []
            },
            {
              index: 3,
              title: 'NUEVA ERA EN EQUIPAMIENTO',
              subtitle: 'Motor / Transmisión',
              image: 'assets/img/Models/G7/Submodels/4x4 MT/char-3.webp',
              table: []
            },
          ]
        },
        {
          index: 2,
          model: 'assets/img/Models/G7/Submodels/4x4 AT/g7-4x4-at-title.webp',
          image: 'assets/img/Models/G7/Submodels/4x4 AT/g7-4x4-model.webp',
          characteristics: [
            {
              index: 0,
              title: 'NUEVA ERA EN POTENCIA',
              subtitle: 'Motor / Transmisión',
              image: 'assets/img/Models/G7/Submodels/4x4 AT/char-1.webp',
              table: []
            },
            {
              index: 1,
              title: 'NUEVA ERA EN SEGURIDAD',
              subtitle: 'Motor / Transmisión',
              image: 'assets/img/Models/G7/Submodels/4x4 AT/char-4.webp',
              table: []
            },
            {
              index: 2,
              title: 'NUEVA ERA EN COMODIDAD',
              subtitle: 'Motor / Transmisión',
              image: 'assets/img/Models/G7/Submodels/4x4 AT/char-2.webp',
              table: []
            },
            {
              index: 3,
              title: 'NUEVA ERA EN EQUIPAMIENTO',
              subtitle: 'Motor / Transmisión',
              image: 'assets/img/Models/G7/Submodels/4x4 AT/char-3.webp',
              table: []
            },
          ]
        }
      ],
    },
    //Tunland G9
    {
      index: 1,
      title: 'assets/img/Models/G9/g9-title.webp',
      videos: ['assets/video/FOTON TUNLAND.mov'],
      dataSheet: 'assets/pdf/tunlandG7.pdf',
      colors: [
        {
          index: 0,
          color: '#000000',
          image: 'assets/img/Models/G9/Colors/g9-black.webp',
          title: 'assets/img/Models/G9/g9-title-alt.webp',
          thick: 'white',
        },
        {
          index: 1,
          color: '#FFFFFF',
          image: 'assets/img/Models/G9/Colors/g9-white.webp',
          title: 'assets/img/Models/G9/g9-title-alt.webp',
          thick: 'black',
        },
        {
          index: 2,
          color: '#718080',
          image: 'assets/img/Models/G9/Colors/g9-silver.webp',
          title: 'assets/img/Models/G9/g9-title-alt.webp',
          thick: 'white',
        }
      ],
      gallery: [
        {
          index: 0,
          url: "assets/img/Models/G9/Gallery/FOTON-TUNLAND-G9-FICHA-TECNICA-PORTADA-BACK-V2-FLAT.jpg",
          alt: "800",
          id: "800",
        },
        {
          index: 1,
          url: "assets/img/Models/G9/Gallery/FOTON_TUNLAND-G9-FOTOESTUDIO-ASIENTO.jpg",
          alt: "801",
          id: "801",
        },
        {
          index: 2,
          url: "assets/img/Models/G9/Gallery/FOTON_TUNLAND-G9-FOTOESTUDIO-MOTOR.jpg",
          alt: "803",
          id: "803",
        },
        {
          index: 3,
          url: "assets/img/Models/G9/Gallery/FOTON_TUNLAND-G9-FOTOESTUDIO-TABLERO.jpg",
          alt: "805",
          id: "805",
        },
        {
          index: 3,
          url: "assets/img/Models/G9/Gallery/FOTON_TUNLAND-G9-FOTOESTUDIO_PANTALLA.jpg",
          alt: "805",
          id: "805",
        },
      ],
      submodels: [
        {
          index: 0,
          model: 'assets/img/Models/G9/Submodels/MT/g9-4x4-mt-title.webp',
          image: 'assets/img/Models/G9/Submodels/MT/g9-4x4-model.webp',
          characteristics: [
            {
              index: 0,
              title: 'NUEVA ERA EN POTENCIA',
              subtitle: 'Motor / Transmisión',
              image: 'assets/img/Models/G9/Submodels/MT/char-1.webp',
              table: []
            },
            {
              index: 1,
              title: 'NUEVA ERA EN SEGURIDAD',
              subtitle: 'Motor / Transmisión',
              image: 'assets/img/Models/G9/Submodels/MT/char-2.webp',
              table: []
            },
            {
              index: 2,
              title: 'NUEVA ERA EN COMODIDAD',
              subtitle: 'Motor / Transmisión',
              image: 'assets/img/Models/G9/Submodels/MT/char-3.webp',
              table: []
            },
            {
              index: 3,
              title: 'NUEVA ERA EN EQUIPAMIENTO',
              subtitle: 'Motor / Transmisión',
              image: 'assets/img/Models/G9/Submodels/MT/char-4.webp',
              table: []
            },
          ]
        },
        {
          index: 1,
          model: 'assets/img/Models/G9/Submodels/AT/g9-4x4-at-title.webp',
          image: 'assets/img/Models/G9/Submodels/AT/g9-4x4-model.webp',
          characteristics: [
            {
              index: 0,
              title: 'NUEVA ERA EN POTENCIA',
              subtitle: 'Motor / Transmisión',
              image: 'assets/img/Models/G9/Submodels/AT/char-1.webp',
              table: []
            },
            {
              index: 1,
              title: 'NUEVA ERA EN SEGURIDAD',
              subtitle: 'Motor / Transmisión',
              image: 'assets/img/Models/G9/Submodels/AT/char-2.webp',
              table: []
            },
            {
              index: 2,
              title: 'NUEVA ERA EN COMODIDAD',
              subtitle: 'Motor / Transmisión',
              image: 'assets/img/Models/G9/Submodels/AT/char-3.webp',
              table: []
            },
            {
              index: 3,
              title: 'NUEVA ERA EN EQUIPAMIENTO',
              subtitle: 'Motor / Transmisión',
              image: 'assets/img/Models/G9/Submodels/AT/char-4.webp',
              table: []
            },
          ]
        }
      ],
    }
  ]

  model = this.models[0]
  color = this.model.colors[0]
  submodel = this.model.submodels[0]
  characteristic = this.submodel.characteristics[0]
  video = this.model.videos[0]

  icons = {
    model: "assets/img/Modelos.png",
    prev: "assets/img/Prev.png",
    next: "assets/img/Next.png",
    gallery: "assets/img/Galeria.png",
    download: "assets/img/ficha.png"
  }
  versiones = [
    {
      model: "Tunland",
      version: 'G7',
      trim: '4x2',
      label: "Tunland G7 4x2 T/M DSL",
      value: "Tunland G7 4x2 T/M DSL"
    },
    {
      model: "Tunland",
      version: 'G7',
      trim: '4x4',
      label: "Tunland G7 4x4 T/M DSL",
      value: "Tunland G7 4x4 T/M DSL"
    },
    {
      model: "Tunland",
      version: 'G7',
      trim: '4x4',
      label: "Tunland G7 4x4 T/A DSL",
      value: "Tunland G7 4x4 T/A DSL"
    },
    {
      model: "Tunland",
      version: 'G9',
      trim: '4x4',
      label: "Tunland G9 4x4 T/A DSL",
      value: "Tunland G9 4x4 T/A DSL"
    },
    {
      model: "Tunland",
      version: 'G9',
      trim: '4x4',
      label: "Tunland G9 4x4 T/M DSL",
      value: "Tunland G9 4x4 T/M DSL"
    }
  ]
  canales = [
    {
      label: "Correo electrónico",
      value: "Mail"
    },
    {
      label: "WhatsApp",
      value: "Whatsapp"
    },
    {
      label: "Llamada telefónica",
      value: "Llamada"
    }
  ]
  concesionarios = [
    {
      label: "Foton Quito Norte",
      city: "QUITO",
      cityTag: "FOTON ECUADOR QUITO NORTE",
      partner: "Foton",
      address: "Foton Quito Norte",
      value: "353001"
    },
    {
      label: "Foton Quito Sur",
      city: "QUITO",
      cityTag: "FOTON ECUADOR QUITO SUR",
      partner: "Foton",
      address: "Foton Quito Sur",
      value: "353010"
    },
    {
      label: "RED AYASA Orellana UIO",
      city: "QUITO",
      cityTag: "RED AYASA Orellana UIO",
      partner: "RED AYASA",
      address: "RED AYASA Orellana UIO",
      value: "480003"
    },
    {
      label: "RED AYASA Eloy Alfaro UIO",
      city: "QUITO",
      cityTag: "RED AYASA Eloy Alfaro UIO",
      partner: "RED AYASA",
      address: "RED AYASA Eloy Alfaro UIO",
      value: "480004"
    },
    {
      label: "Hipermotor Manta",
      city: "MANTA",
      cityTag: "FOTON ECUADOR MANTA",
      partner: "Foton",
      address: "Hipermotor Manta",
      value: "353007"
    },
    {
      label: "RED AYASA Manta",
      city: "MANTA",
      cityTag: "RED AYASA Manta",
      partner: "RED AYASA",
      address: "RED AYASA Manta",
      value: "480002"
    }, 
    {
      label: "Foton Guayaquil Juan Tanca Marengo",
      city: "GUAYAQUIL",
      cityTag: "FOTON ECUADOR GUAYAQUIL",
      partner: "Foton",
      address: "Foton Guayaquil Juan Tanca Marengo",
      value: "353002"
    },
    {
      label: "Fangio Daule",
      city: "GUAYAQUIL",
      cityTag: "FOTON FANGIO DAULE",
      partner: "Foton",
      address: "Fangio Daule",
      value: "353006"
    },
    {
      label: "Maxdrive Quito Norte",
      city: "QUITO",
      cityTag: "FOTON MAXDRIVE QUITO",
      partner: "Maxdrive",
      address: "Maxdrive Quito Norte",
      value: "353013"
    },
    {
      label: "Maxdrive Guayaquil (Yaguachi)",
      city: "GUAYAQUIL",
      cityTag: "FOTON MAXDRIVE GUAYAQUIL",
      partner: "Maxdrive",
      address: "Maxdrive Guayaquil (Yaguachi)",
      value: "353014"
    },
    {
      label: "RED AYASA Orellana GYQ",
      city: "GUAYAQUIL",
      cityTag: "RED AYASA Orellana GYQ",
      partner: "RED AYASA",
      address: "RED AYASA Orellana GYQ",
      value: "480005"
    },
    {
      label: "RED AYASA El Dorado GYQ",
      city: "GUAYAQUIL",
      cityTag: "RED AYASA El Dorado GYQ",
      partner: "RED AYASA",
      address: "RED AYASA El Dorado GYQ",
      value: "480007"
    },
    {
      label: "Foton Ambato",
      city: "AMBATO",
      cityTag: "FOTON AMBATO",
      partner: "Foton",
      address: "Foton Ambato",
      value: "353011"
    },
    {
      label: "Amercom Cuenca",
      city: "CUENCA",
      cityTag: "FOTON CUENCA",
      partner: "Amercom",
      address: "Amercom Cuenca",
      value: "353012"
    },
    {
      label: "Hipermotor Portoviejo",
      city: "PORTOVIEJO",
      cityTag: "FOTON PORTOVIEJO",
      partner: "Foton",
      address: "Hipermotor Portoviejo",
      value: "353016"
    },
    {
      label: "Hipermotor Santo Domingo",
      city: "SANTO DOMINGO",
      cityTag: "FOTON SANTO DOMINGO",
      partner: "Foton",
      address: "Hipermotor Santo Domingo",
      value: "353017"
    },
    {
      label: "Amercom Loja",
      city: "LOJA",
      cityTag: "FOTON LOJA",
      partner: "Amercom",
      address: "Amercom Loja",
      value: "353015"
    }
  ]
  ciudades = [
    {
      label: "Quito",
      value: "QUITO"
    },
    {
      label: "Guayaquil",
      value: "GUAYAQUIL"
    },
    {
      label: "Manta",
      value: "MANTA"
    },
    {
      label: "Ambato",
      value: "AMBATO"
    },
    {
      label: "Cuenca",
      value: "CUENCA"
    },
    {
      label: "Loja",
      value: "LOJA"
    },
    {
      label: "Portoviejo",
      value: "PORTOVIEJO"
    },
    {
      label: "Santo Domingo",
      value: "SANTO DOMINGO"
    }
  ]

  @ViewChild('target1') public target1: ElementRef;
  @ViewChild('target2') public target2: ElementRef;
  @ViewChild('cotizador') public cotizador: ElementRef;
  @ViewChild('videoPlayer') public videoPlayer: ElementRef;

  private observer: IntersectionObserver;
  loadedAnimationIDs = [];

  constructor(@Inject(DOCUMENT) private document: Document,
    private backendService: BackendService,
    public deviceService: DeviceDetectorService,
    fb: FormBuilder, private animateScrollService: NgAnimateScrollService) {
    smoothscroll.polyfill();
    this.valForm = fb.group({
      'email': [null, Validators.compose([Validators.required, CustomValidators.email])],
      'nombre': [null, Validators.required],
      'apellido': [null, Validators.required],
      'telefono': [null, Validators.required],
      'version': [null, Validators.required],
      'canal': [null, Validators.required],
      'ciudad': [null, Validators.required],
      'concesionario': [null, Validators.required]
    });
  }

  @HostListener('window:scroll', ['$event']) // for window scroll events
  onScroll(event) {

  }

  scrollTo(element: any) {
    element.scrollIntoView({ block: 'start', inline: 'nearest', duration: 3000, behavior: "smooth" });
    //element.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'end' });
  }

  setModel(index?: number){
    const colorIndex = this.color.index || 0
    if(index !== undefined){
      this.model = this.models.find(e => e.index === index)
    } else {
      this.model = this.models.length === this.model.index + 1 ? this.models[0] : this.models.find(e => e.index === this.model.index + 1)
    }
    
    this.color = this.model.colors.length > colorIndex ? this.model.colors[colorIndex] : this.model.colors[0]
    this.submodel = this.model.submodels[0]
    this.characteristic = this.submodel.characteristics[0]
  }

  setSubModel(index?: number){
    const characteristicIndex = this.characteristic.index || 0
    if(index !== undefined){
      this.submodel = this.model.submodels.find(e => e.index === index)
    } else {
      this.submodel = this.model.submodels.length === this.submodel.index + 1 ?  this.model.submodels[0] : this.model.submodels.find(e => e.index === this.submodel.index + 1)
    }
    this.characteristic = this.submodel.characteristics[characteristicIndex]
  }

  setColor(index?: number, preview?: boolean){
    if(index !== undefined) {
      this.color = this.model?.colors.find(c => c.index === index)
    } else {
      if (preview) {
        this.color = this.color.index === 0 ? this.model?.colors[this.model?.colors.length - 1]: this.model?.colors.find(c => c.index === this.color.index - 1)
      } else {
        this.color = this.model?.colors.length === this.color.index + 1 ? this.model?.colors[0] : this.model?.colors.find(c => c.index === this.color.index + 1)
      }
    }
  }

  setCharacteristic(index?: number){
    this.characteristic = this.submodel?.characteristics.find(c => c.index === index)
  }

  navigateTo(id: string, duration?: number) {
    this.animateScrollService.scrollToElement(id, duration)
  }

  ngAfterViewChecked(){
    /* if (this.videoPlayer){
      setTimeout(()=> {
        this.muted = false;
        this.playVideo()
      }, 0);
    }   */
  }    

  stopVideo() {
    this.playing = false;
    this.videoPlayer.nativeElement.pause();
  }

  unmuteVideo() {
    if (this.videoPlayer.nativeElement.muted === true){
      this.muted = false;
      this.videoPlayer.nativeElement.muted = false;
    } else {
      this.muted = true;
      this.videoPlayer.nativeElement.muted = true;
    }
    
  }
  playVideo() {
    this.playing = true;
    this.firstTime = false;
    this.videoPlayer.nativeElement.play();
  }

  ngOnInit() {

    var body = document.getElementsByTagName("body")[0];
    body.classList.add("home-page");
  }

  async submitForm($ev, value: any) {
    $ev.preventDefault();
    for (let c in this.valForm.controls) {
      this.valForm.controls[c].markAsTouched();
    }
    if (this.valForm.valid) {
      this.send = true;
      let city = this.concesionarios.find(e => e.value === this.valForm.value.concesionario)
      let date = new Date
      let dateString = new Date(date.getTime() - 60000 * date.getTimezoneOffset())
      const model = this.versiones.find(v => v.value === this.valForm.value?.version)
      let xml = `<?xml version="1.0" encoding="UTF-8"?>
                <adf>
                  <prospect status="new">
                    <id sequence="norlopjwt">${dateString.toISOString().substr(2, 2)}${dateString.toISOString().substr(5, 2)}${dateString.toISOString().substr(8, 2)}${dateString.toISOString().substr(11, 2)}${dateString.toISOString().substr(14, 2)}${dateString.toISOString().substr(17, 2)}</id>
                    <requestdate>${dateString.toISOString().substr(0, 10)} ${dateString.toISOString().substr(11, 8)}</requestdate>
                    <vehicle interest="buy" status="new">            
                      <make>${city?.partner}</make>
                      <model>${model?.model}</model>
                      <trim>${model?.trim}</trim>
                      <version>${model?.version}</version>
                    </vehicle>
                    <customer>
                      <contact>
                        <name part="full">${this.valForm.value.nombre} ${this.valForm.value.apellido}</name>
                        <email>${this.valForm.value.email}</email>
                        <phone>${this.valForm.value.telefono}</phone>
                      </contact>
                      <comments>Canal de Contacto: ${this.valForm.value.canal} Tipo de Vehículo: ${this.valForm.value.version}<origin>${model?.version?.toLowerCase()}</origin></comments>
                    </customer>
                    <vendor>
                      <id source="norlopjwt">${city?.value}</id>
                      <vendorname>${city?.cityTag}</vendorname>
                      <url>foton-tunland.com</url>
                    </vendor>
                  </prospect>
                  <provider>
                    <name>FotonWeb</name>
                    <service>Cotizacion</service>
                  </provider>
                </adf>`;
      let fields = [];

      let that = this;
      this.backendService.createSeekop(xml).subscribe(function (response) { 
        const parser = new xml2js.Parser({ strict: false, trim: true });
        parser.parseString(response, (err, result) => {
          if (result.ADFRESPONSELIST.ADFRESPONSE.length){
            if (result.ADFRESPONSELIST.ADFRESPONSE[0].PROSPECTSTATUS.length){
              if (result.ADFRESPONSELIST.ADFRESPONSE[0].PROSPECTSTATUS[0].$){
                that.backendService.createContact({
                  nombre: that.valForm.value.nombre,
                  apellido: that.valForm.value.apellido,
                  telefono: that.valForm.value.telefono,
                  email: that.valForm.value.email,
                  version: that.valForm.value.version,
                  canal: that.valForm.value.canal,
                  ciudad: that.valForm.value.ciudad,
                  concesionario: that.valForm.value.concesionario,
                  concesionarioDesc: city.address,
                  prospect: result.ADFRESPONSELIST.ADFRESPONSE[0].PROSPECTSTATUS[0].$.IDPROSPECTO
                }).subscribe(function (response) {
                })
              }
            }
          }
        });
      });
      
      fields.push({
        name: "nombre",
        values: [this.valForm.value.nombre]
      });
      fields.push({
        name: "apellido",
        values: [this.valForm.value.apellido]
      });
      fields.push({
        name: "telefono",
        values: [this.valForm.value.telefono]
      });
      fields.push({
        name: "email",
        values: [this.valForm.value.email]
      });
      fields.push({
        name: "version",
        values: [this.valForm.value.version]
      });
      fields.push({
        name: "canal",
        values: [this.valForm.value.canal]
      });
      fields.push({
        name: "ciudad",
        values: [this.valForm.value.ciudad]
      });
      fields.push({
        name: "concesionario",
        values: [this.valForm.value.concesionario]
      });
      fields.push({
        name: "concesionarioDesc",
        values: [city.address]
      });
    }
  }

  filterConcesionarios(city) {
    return this.concesionarios.filter(x => x.city == city);
  }

  changeVideo(index) {
    this.video = this.model?.videos[index];
    this.videoPlayer.nativeElement.src = this.video;
    this.videoPlayer.nativeElement.muted = false;
    this.videoPlayer.nativeElement.load();
    this.videoPlayer.nativeElement.play();
  }

  ngAfterViewInit() {
    //this.removeAllAnimations();

    this.observer = new IntersectionObserver(entries => {

      if (entries[0].isIntersecting === true) {
        //console.log('visible');
        this.refreshSlideElement("#" + entries[0].target.id);
      }

    }, {
      threshold: 0.2
    });
    const image4 = document.querySelector('#image4');
    this.observer.observe(image4 as HTMLElement);

    const image3 = document.querySelector('#image3');
    this.observer.observe(image3 as HTMLElement);
  }



  removeAllAnimations() {
    var elems = document.getElementsByClassName("animate__animated");

    console.log(elems.length);

    [].forEach.call(elems, function (el) {
      console.log(el);
      el.classList.remove("animate__animated");
    });

  }

  refreshSlideElement(id) {

    if (!this.loadedAnimationIDs.includes(id)) {
      this.loadedAnimationIDs.push(id);

      var element = document.querySelector(id) as HTMLElement;


      if (id == '#image4') {
        element.classList.add('animate__animated');
        element.classList.add('animate__fadeInLeft');
        element.classList.add('animate__delay-0.5s');
      }

      if (id == '#image3') {
        element.classList.add('animate__animated');
        element.classList.add('animate__fadeInLeft');
        setTimeout(async function () {
          this.selectedVehicle = {
            name: "Negra",
            color: "#000000",
            url: "assets/img/TUNLAND G7 NEGRA 1378×768 .png",
            thick: "white",
            loaded: true
          }
        }, 1000)
      }

    }

  };

  ngOnDestroy() {
    var body = document.getElementsByTagName("body")[0];
    body.classList.remove("home-page");
    this.observer.disconnect();
  }


  getImageOpacity(position: number): number {

    var opacity = 0;
    let gap = 0;

    let scrollPercent = (window.pageYOffset / window.innerHeight) / 3 * 100;

    //let diff = Math.abs(position - scrollPercent);
    let diff = position - scrollPercent;

    if (diff <= gap) {
      opacity = 1;
    } else {
      opacity = 1 - (diff / 100) * 5;
    }

    return opacity;
  }

  getImageTransparency(position: number): number {

    var opacity = 0;
    let gap = 0.1;

    let scrollPercent = (window.pageYOffset / window.innerHeight) / 3 * 100;

    //let diff = Math.abs(position - scrollPercent);
    let diff = position - scrollPercent;

    if (diff <= gap) {
      opacity = 0;
    } else {
      opacity = (diff / 100) * 6;

      if (opacity > 1.0) {
        opacity = 1.0;
      }

    }

    return opacity;
  }

  clicLink(link) {
    this.document.location.href = link;
  }

}
